import { TMessage } from "../types"

export const normalizeMessagePage = (page: unknown): TMessage[] => {
  if (Array.isArray(page)) {
    return page
  }

  if (page && typeof page === "object") {
    const record = page as Record<string, unknown>

    if (Array.isArray(record.rows)) {
      return record.rows
    }

    if (Array.isArray(record.data)) {
      return record.data
    }

    if (Array.isArray(record.messages)) {
      return record.messages
    }
  }

  return []
}

export const flattenMessagePages = (
  pages: unknown[] | undefined,
): TMessage[] => {
  if (!pages?.length) {
    return []
  }

  return pages.flatMap((page) => normalizeMessagePage(page))
}
